import template from "./dashboard-page.html";
import debounce from "lodash/debounce";

const DashboardPageComponent = {
  bindings: {
    organization: "<",
  },
  template: template,
  controller: class DashboardPageController {
    /* @ngInject */
    constructor(
      $state,
      $scope,
      $rootScope,
      $filter,
      SecurityManager,
      Quote,
      ModalsManager,
      SweetAlertService,
      Utils,
      notifications,
      Notification,
      localStorageService,
    ) {
      this.$window = $(window);
      this.$state = $state;
      this.$scope = $scope;
      this.$filter = $filter;
      this.$rootScope = $rootScope;
      this.SecurityManager = SecurityManager;
      this.Quote = Quote;
      this.ModalsManager = ModalsManager;
      this.SweetAlertService = SweetAlertService;
      this.Utils = Utils;
      this.NotificationsBarService = notifications;
      this.NotificationService = Notification;
      this.localStorageService = localStorageService;
    }

    async $onInit() {
      this.quotes = [];
      this.quotesCount = { archived: {}, active: {} };
      this.templateSelectorUrl = this.$state.href("app.templateSelector");
      this.loading = false;
      this.includesOptionSelected = "Solo Activos";
      this.includesOptions = ["Todos", "Solo Activos", "Solo Archivados"];
      this.searchOptions = {
        description: "",
        from: "",
        until: "",
        statusNone: true,
        statusApproved: true,
        statusRejected: true,
        archived: false,
        sortOrder: -1,
        page: 1,
      };

      this.SweetAlertService.close();

      await this.refreshQuotesAndCount();

      this.$scope.$watch(
        () => this.searchOptions.description,
        debounce((newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            this.searchOptions.description = newVal;
            this.refreshQuotesAndCount().then();
          }
        }, 500),
      );

      this.$scope.$watch(
        () => this.searchOptions.from,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            this.searchOptions.from = newVal;
            this.refreshQuotesAndCount().then();
          }
        },
      );

      this.$scope.$watch(
        () => this.searchOptions.until,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            this.searchOptions.until = newVal;
            this.refreshQuotesAndCount().then();
          }
        },
      );
    }

    toggleFilterStatusNone() {
      this.searchOptions.statusNone = !this.searchOptions.statusNone;
      this.refreshQuotesAndCount().then();
    }

    toggleFilterStatusApproved() {
      this.searchOptions.statusApproved = !this.searchOptions.statusApproved;
      this.refreshQuotesAndCount().then();
    }

    toggleFilterStatusRejected() {
      this.searchOptions.statusRejected = !this.searchOptions.statusRejected;
      this.refreshQuotesAndCount().then();
    }

    toggleFilterArchived() {
      if (this.includesOptionSelected === "Solo Activos") {
        this.searchOptions.archived = false;
      } else if (this.includesOptionSelected === "Solo Archivados") {
        this.searchOptions.archived = true;
      } else if (this.includesOptionSelected === "Todos") {
        this.searchOptions.archived = undefined;
      }

      this.refreshQuotesAndCount().then();
    }

    showQuotesCount(status) {
      if (this.searchOptions.archived === true) return this.quotesCount.archived[status];
      else if (this.searchOptions.archived === false) return this.quotesCount.active[status];
      else return this.quotesCount.archived[status] + this.quotesCount.active[status];
    }

    countQuotesOnList() {
      return this.quotes.length;
    }

    goTemplatesLibrary() {
      this.$state.go("app.templateSelector");
    }

    changeSortOrder() {
      this.searchOptions.sortOrder = this.searchOptions.sortOrder * -1;
      this.refreshQuotes().then();
    }

    async loadMoreQuotes() {
      const loadedQuotes = this.quotes.length;
      const quotesToLoad = this._getQuotesToLoad();
      if (loadedQuotes !== quotesToLoad && !this.loading) {
        this.searchOptions.page++;
        const quotes = await this.loadQuotes();
        this.quotes = this.quotes.concat(quotes);
        this.$rootScope.$applyAsync();
      }
    }

    async loadQuotes() {
      const status = [];
      if (this.searchOptions.statusNone) status.push("none");
      if (this.searchOptions.statusApproved) status.push("approved");
      if (this.searchOptions.statusRejected) status.push("rejected");
      if (status.length === 0) return [];

      this.loading = true;
      const quotes = await this.Quote.query({
        q: this.searchOptions.description || "",
        status: status.join(",") || "",
        archived: this.searchOptions.archived,
        sortOrder: this.searchOptions.sortOrder,
        from: this.searchOptions.from,
        until: this.searchOptions.until,
        page: this.searchOptions.page,
      });
      this.loading = false;
      this.$rootScope.$applyAsync();

      return quotes;
    }

    async loadQuotesCount() {
      this.quotesCount = await this.Quote.getCount({
        q: this.searchOptions.description,
        from: this.searchOptions.from,
        until: this.searchOptions.until,
      });
      if (this.quotesCount.totalNoFilter === 0) this.$rootScope.hasQuotes = false;
      else this.$rootScope.hasQuotes = true;
      this.$rootScope.$applyAsync();
    }

    async refreshQuotes() {
      this.quotes = [];
      if ($(".tooltip").is(":visible")) $(".tooltip").hide();
      this._resetPagination();
      this.quotes = await this.loadQuotes();
      this.$rootScope.$applyAsync();
    }

    noQuotes() {
      return this.quotesCount.totalNoFilter === 0;
    }

    noFilteredQuotes() {
      return this.quotes.length === 0;
    }

    refreshQuotesAndCount() {
      return Promise.all([this.loadQuotesCount(), this.refreshQuotes()]).then((result) => {
        $(".tooltip").tooltip("hide");
        return result;
      });
    }

    _resetPagination() {
      this.searchOptions.page = 1;
    }

    _getQuotesToLoad() {
      let quotesToLoad = this.quotesCount.total;
      if (this.searchOptions.archived === false) {
        if (!this.searchOptions.statusNone) quotesToLoad = quotesToLoad - this.quotesCount.active.none;
        if (!this.searchOptions.statusApproved) quotesToLoad = quotesToLoad - this.quotesCount.active.approved;
        if (!this.searchOptions.statusRejected) quotesToLoad = quotesToLoad - this.quotesCount.active.rejected;
        quotesToLoad = quotesToLoad - this.quotesCount.archived.total;
      } else if (this.searchOptions.archived === true) {
        if (!this.searchOptions.statusNone) quotesToLoad = quotesToLoad - this.quotesCount.archived.none;
        if (!this.searchOptions.statusApproved) quotesToLoad = quotesToLoad - this.quotesCount.archived.approved;
        if (!this.searchOptions.statusRejected) quotesToLoad = quotesToLoad - this.quotesCount.archived.rejected;
        quotesToLoad = quotesToLoad - this.quotesCount.active.total;
      } else {
        if (!this.searchOptions.statusNone) {
          quotesToLoad = quotesToLoad - this.quotesCount.active.none;
          quotesToLoad = quotesToLoad - this.quotesCount.archived.none;
        }
        if (!this.searchOptions.statusApproved) {
          quotesToLoad = quotesToLoad - this.quotesCount.active.approved;
          quotesToLoad = quotesToLoad - this.quotesCount.archived.approved;
        }
        if (!this.searchOptions.statusRejected) {
          quotesToLoad = quotesToLoad - this.quotesCount.active.rejected;
          quotesToLoad = quotesToLoad - this.quotesCount.archived.rejected;
        }
      }

      return quotesToLoad;
    }
  },
};

export default DashboardPageComponent;
